import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import {
    FETCH_FB_TOKENS,
    FETCH_IG_TOKENS,
    FETCH_LINKEDIN_TOKENS,
    TWITTER_AUTHENTICATE,
    FETCH_TOKEN_LIST,
    FETCH_AD_ACCOUNT_LIST,
    TIKTOK_AUTHENTICATE,
    LINKEDIN_AUTHENTICATE,
    GET_LINKEDIN_PAGE_LIST,
} from "../actions/tokensAction";

const tokensReducer = (
    state = {
        fbTokensListLoading: false,
        fbTokensListError: null,
        fbTokenList: [],
        igTokensListLoading: false,
        igTokenList: [],
        lkdnTokenList: [],
        lkdnTokensListLoading: false,

        twitterLoginStatus: false,
        twitterAuthenticationFailed: false,
        tiktokLoginStatus: false,
        tiktokAuthenticationFailed: false,
        linkedinLoginStatus: false,
        linkedinAuthenticationFailed: false,
        tokenList: [],
        tokenListLoading: false,
        adAccounts: [],

        //linkedin page list
        linkedinPages: [],
        linkedinExpiresIn: "",
        linkedinAccessToken: "",
    },
    action,
) => {
    switch (action.type) {
        case isPending(FETCH_FB_TOKENS):
            return (state = {
                ...state,
                fbTokensListLoading: true,
                fbTokenList: [],
            });

        case isRejected(FETCH_FB_TOKENS):
            return (state = {
                ...state,
                fbTokensListLoading: false,
                fbTokenList: [],
            });

        case isFulfilled(FETCH_FB_TOKENS):
            return (state = {
                ...state,
                fbTokensListLoading: false,
                fbTokenList: action.payload,
            });

        case isPending(FETCH_TOKEN_LIST):
            return (state = {
                ...state,
                tokenListLoading: true,
                tokenList: [],
            });

        case isRejected(FETCH_TOKEN_LIST):
            return (state = {
                ...state,
                tokenListLoading: false,
                tokenList: [],
            });

        case isFulfilled(FETCH_TOKEN_LIST):
            return (state = {
                ...state,
                tokenListLoading: false,
                tokenList: action.payload,
            });

        case isPending(FETCH_IG_TOKENS):
            return (state = {
                ...state,
                igTokensListLoading: true,
                igTokenList: [],
            });

        case isRejected(FETCH_IG_TOKENS):
            return (state = {
                ...state,
                igTokensListLoading: false,
                igTokenList: [],
            });

        case isFulfilled(FETCH_IG_TOKENS):
            return (state = {
                ...state,
                igTokensListLoading: false,
                igTokenList: action.payload,
            });
        case isPending(FETCH_LINKEDIN_TOKENS):
            return (state = {
                ...state,
                lkdnTokensListLoading: true,
                lkdnTokenList: [],
            });

        case isRejected(FETCH_LINKEDIN_TOKENS):
            return (state = {
                ...state,
                lkdnTokensListLoading: false,
                lkdnTokenList: [],
            });

        case isFulfilled(FETCH_LINKEDIN_TOKENS):
            return (state = {
                ...state,
                lkdnTokensListLoading: false,
                lkdnTokenList: action.payload,
            });

        case isRejected(TWITTER_AUTHENTICATE):
            return (state = {
                ...state,
                twitterLoginStatus: false,
                twitterAuthenticationFailed: true,
            });
        case isFulfilled(TWITTER_AUTHENTICATE):
            if (action.payload?.status === "success") {
                return (state = {
                    ...state,
                    twitterLoginStatus: true,
                    twitterAuthenticationFailed: false,
                });
            } else {
                return (state = {
                    ...state,
                    twitterLoginStatus: false,
                    twitterAuthenticationFailed: true,
                });
            }
        case isRejected(TIKTOK_AUTHENTICATE):
            return (state = {
                ...state,
                tiktokLoginStatus: false,
                tiktokAuthenticationFailed: true,
            });
        case isFulfilled(TIKTOK_AUTHENTICATE):
            if (action.payload?.status === "success") {
                return (state = {
                    ...state,
                    tiktokLoginStatus: true,
                    tiktokAuthenticationFailed: false,
                });
            } else {
                return (state = {
                    ...state,
                    tiktokLoginStatus: false,
                    tiktokAuthenticationFailed: true,
                });
            }
        case isRejected(LINKEDIN_AUTHENTICATE):
            return (state = {
                ...state,
                linkedinLoginStatus: false,
                linkedinAuthenticationFailed: true,
            });
        case isFulfilled(LINKEDIN_AUTHENTICATE):
            if (action.payload?.status === "success") {
                return (state = {
                    ...state,
                    linkedinLoginStatus: true,
                    linkedinAuthenticationFailed: false,
                });
            } else {
                return (state = {
                    ...state,
                    linkedinLoginStatus: false,
                    linkedinAuthenticationFailed: true,
                });
            }
        case isFulfilled(GET_LINKEDIN_PAGE_LIST):
            // if (action.payload?.status === "success") {
            // console.log("first", action.payload);
            return (state = {
                ...state,
                linkedinPages: action.payload.pages,
                linkedinExpiresIn: action.payload.expires_in,
                linkedinAccessToken: action.payload.access_token,
            });
        // } else {
        //     return (state = {
        //         ...state,
        //         linkedinLoginStatus: false,
        //         linkedinAuthenticationFailed: true,
        //     });
        // }

        case isFulfilled(FETCH_AD_ACCOUNT_LIST):
            if (state.adAccounts.filter((el) => el.user_social_id === action.payload[0]?.user_social_id).length === 0 || state.adAccounts.length === 0) {
                return (state = {
                    ...state,
                    adAccounts: [...state.adAccounts, ...action.payload],
                });
            } else return state;

        default:
            return state;
    }
};

export default tokensReducer;
